var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-news-post"},[_c('div',{class:[
      'section-title d-flex justify-content-between align-items-center',
      _vm.darkClass && 'title' in _vm.darkClass ? _vm.darkClass.title : '',
    ]},[_c('h3',{staticClass:"title"},[_vm._v("市场验证案例")]),_c('router-link',{attrs:{"to":"/articles?channel=4"}},[_vm._v("查看更多")])],1),_c('div',{staticClass:"business-post"},[_vm._l((_vm.TrendingPosts),function(data,index){return [_c('div',{key:index,class:[
          'business-post-item  mb-40',
          _vm.darkClass && 'item' in _vm.darkClass ? _vm.darkClass.item : '',
        ]},[(data)?_c('divide-card',{attrs:{"readMore":true,"stype":"row","datas":data}}):_vm._e()],1)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }